import { render, staticRenderFns } from "./FirstRechargeList.vue?vue&type=template&id=0a2470d1&scoped=true"
import script from "./FirstRechargeList.vue?vue&type=script&lang=js"
export * from "./FirstRechargeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2470d1",
  null
  
)

export default component.exports